module.exports = __webpack_public_path__ + "static/media/1011243.b05d1788.png";